import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './components/styleCss/a.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { HelmetProvider } from 'react-helmet-async';

import zipy from "zipyai";

zipy.init("4746b0c0");



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <HelmetProvider>
    <BrowserRouter>


      <App />

    </BrowserRouter>

  </HelmetProvider>


  //  <React.StrictMode>y

  //  <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
